import React from "react";
import styled, { css } from "styled-components";
import { borderRadiusS, colorBrandRhumbixYellow, colorFunctionalBlack, colorFunctionalGray20, colorFunctionalGray30, colorFunctionalGray50, colorFunctionalGray70, colorFunctionalWhite, colorMiscGray80, colorMiscYellow30, fontSizeM, spacingS, } from "@rhumbix/rmbx_design_system_design_tokens";
const CTAButton = ({ text, theme, icon, iconPosition = "left", ...htmlProps }) => {
    const btnContent = (React.createElement(ButtonWrapper, null,
        icon && iconPosition === "left" && icon,
        icon && iconPosition === "left" && React.createElement(IconBuffer, { bufferSide: "right" }),
        text,
        icon && iconPosition === "right" && React.createElement(IconBuffer, { bufferSide: "left" }),
        icon && iconPosition === "right" && icon));
    switch (theme) {
        case "secondary":
            return React.createElement(StyledBtnSecondary, { ...htmlProps }, btnContent);
        case "black":
            return React.createElement(StyledBtnBlack, { ...htmlProps }, btnContent);
        case "primary":
        default:
            return React.createElement(StyledBtnPrimary, { ...htmlProps }, btnContent);
    }
};
const ButtonWrapper = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: center;
`;
const baseButtonStyles = css `
    border-radius: ${borderRadiusS};
    color: ${colorFunctionalBlack};
    font-family: Roboto;
    font-size: ${fontSizeM};
    font-weight: 500;
    min-height: 56px;
    min-width: 210px;
    padding: 16px 24px;
`;
const StyledBtnPrimary = styled.button `
    ${baseButtonStyles}
    background-color: ${colorBrandRhumbixYellow};
    border: 0px;

    &:active {
        background-color: ${colorMiscYellow30};
        color: ${colorMiscGray80};
    }
`;
const StyledBtnSecondary = styled.button `
    ${baseButtonStyles}
    background-color: ${colorFunctionalWhite};
    border: 1px solid ${colorFunctionalGray30};
    color: ${colorMiscGray80};

    &:active {
        border: 1px solid ${colorFunctionalGray50};
        color: ${colorFunctionalGray70};
    }
`;
const StyledBtnBlack = styled.button `
    ${baseButtonStyles}
    background-color: ${colorFunctionalBlack};
    border: 0px;
    color: ${colorFunctionalWhite};

    &:active {
        background-color: ${colorMiscGray80};
        color: ${colorFunctionalGray20};
    }
`;
const IconBuffer = styled.div `
    margin-${props => props.bufferSide}: ${spacingS}
`;
export default CTAButton;
